















import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "StreamMessage",
  components: { BaseAvatar },
  props: {
    message: { type: Object as () => Message, required: true },
  },
  setup() {
    return { resolveUserName };
  },
});
